var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _vm.$userInfo
    ? _c(
        "div",
        [
          _c("app-detail-header", {
            attrs: {
              "show-toggle": false,
              "show-new": false,
              "show-print": false,
              "show-delete": false,
              "show-save": false,
              "show-cancel": false,
            },
            on: { appDetailHeaderButtonClicked: _vm.onHeaderButtonClicked },
          }),
          !_vm.subscription && !_vm.isTableLoading
            ? _c("div", { staticClass: "tile is-parent" }, [_vm._m(0)])
            : _c("div", { staticClass: "columns is-gapless" }, [
                _c(
                  "div",
                  { staticClass: "column is-narrow" },
                  [
                    _c("vehicle-lookup-list-side-menu", {
                      on: { filter: _vm.filterList, reset: _vm.resetList },
                      model: {
                        value: _vm.filter,
                        callback: function ($$v) {
                          _vm.filter = $$v
                        },
                        expression: "filter",
                      },
                    }),
                  ],
                  1
                ),
                _c("div", { staticClass: "column" }, [
                  _c("div", { staticClass: "tile is-parent" }, [
                    _c(
                      "article",
                      { staticClass: "tile is-child box" },
                      [
                        _vm.subscription
                          ? _c("div", { staticClass: "field" }, [
                              _c("div", { staticClass: "field-body" }, [
                                _c("div", { staticClass: "field" }, [
                                  _c("label", { staticClass: "label" }, [
                                    _vm._v("Subscription Date"),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "has-text-weight-bold has-text-primary",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatDateLocale(
                                            _vm.subscription.purchaseDate,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "field" }, [
                                  _c("label", { staticClass: "label" }, [
                                    _vm._v("Balance"),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "has-text-weight-bold has-text-success",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.subscription.balance,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                                _c("div", { staticClass: "field" }, [
                                  _c("label", { staticClass: "label" }, [
                                    _vm._v("Usage"),
                                  ]),
                                  _c(
                                    "span",
                                    {
                                      staticClass:
                                        "has-text-weight-bold has-text-success",
                                    },
                                    [
                                      _vm._v(
                                        _vm._s(
                                          _vm.$filters.formatCurrency(
                                            _vm.subscription.usage,
                                            _vm.$userInfo.locale
                                          )
                                        )
                                      ),
                                    ]
                                  ),
                                ]),
                              ]),
                            ])
                          : _vm._e(),
                        _c("label", { staticClass: "label" }, [
                          _vm._v("Usage History"),
                        ]),
                        _c(
                          "bulma-table",
                          {
                            staticClass:
                              "table is-bordered is-striped is-narrow is-fullwidth",
                            attrs: {
                              columns: _vm.columns,
                              "page-index": _vm.filter.pageIndex,
                              "page-size": _vm.filter.pageSize,
                              "total-rows": _vm.totalRows,
                              "is-loading": _vm.isTableLoading,
                              "sort-column": _vm.filter.sortColumn,
                              "sort-order": _vm.filter.sortOrder,
                            },
                            on: {
                              pageChanged: _vm.onPageChange,
                              sort: _vm.sort,
                            },
                          },
                          [
                            _vm._l(_vm.calllogs, function (c, index) {
                              return _c(
                                "tr",
                                {
                                  key: c.calllogid,
                                  class: {
                                    "is-selected": _vm.selectedRow === index,
                                  },
                                  on: {
                                    click: function ($event) {
                                      return _vm.highlightSelected(
                                        index,
                                        $event
                                      )
                                    },
                                  },
                                },
                                [
                                  _c("td", [_vm._v(_vm._s(c.callLogId))]),
                                  _c("td", [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatDateTimeLocale(
                                          c.callTimestamp,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", [_vm._v(_vm._s(c.username))]),
                                  _c("td", [_vm._v(_vm._s(c.tierName))]),
                                  _c("td", { staticClass: "has-text-right" }, [
                                    _vm._v(
                                      _vm._s(
                                        _vm.$filters.formatCurrency(
                                          c.price,
                                          _vm.$userInfo.locale
                                        )
                                      )
                                    ),
                                  ]),
                                  _c("td", [_vm._v(_vm._s(c.rego))]),
                                  _c("td", [_vm._v(_vm._s(c.stateCode))]),
                                  _c(
                                    "td",
                                    {
                                      staticClass:
                                        "has-text-centered is-content-width",
                                    },
                                    [
                                      _c(
                                        "a",
                                        {
                                          staticClass:
                                            "button is-primary is-small is-inverted tooltip",
                                          attrs: {
                                            "data-tooltip": "Click to view",
                                          },
                                          on: {
                                            click: function ($event) {
                                              $event.preventDefault()
                                              return _vm.view(c, $event)
                                            },
                                          },
                                        },
                                        [
                                          _c(
                                            "span",
                                            { staticClass: "icon is-medium" },
                                            [
                                              _c("i", {
                                                staticClass:
                                                  "mdi mdi-code-json mdi-24px",
                                              }),
                                            ]
                                          ),
                                        ]
                                      ),
                                    ]
                                  ),
                                ]
                              )
                            }),
                            _c("template", { slot: "empty" }, [
                              _c("section", { staticClass: "section" }, [
                                _c(
                                  "div",
                                  {
                                    staticClass:
                                      "content has-text-grey has-text-centered",
                                  },
                                  [
                                    _c(
                                      "span",
                                      { attrs: { icon: "icon is-large" } },
                                      [
                                        _c("i", {
                                          staticClass:
                                            "mdi mdi-48px mdi-emoticon-sad",
                                        }),
                                      ]
                                    ),
                                    _c("p", [_vm._v("Nothing")]),
                                  ]
                                ),
                              ]),
                            ]),
                          ],
                          2
                        ),
                      ],
                      1
                    ),
                  ]),
                ]),
              ]),
        ],
        1
      )
    : _vm._e()
}
var staticRenderFns = [
  function () {
    var _vm = this,
      _c = _vm._self._c
    return _c("article", { staticClass: "tile is-child box" }, [
      _c("article", { staticClass: "message is-danger" }, [
        _c("div", { staticClass: "message-header" }, [
          _c("p", [_vm._v("No Subscription")]),
        ]),
        _c("div", { staticClass: "message-body" }, [
          _vm._v(
            " There is no active subscription. Please contact FlexiQuote support. "
          ),
        ]),
      ]),
    ])
  },
]
render._withStripped = true

export { render, staticRenderFns }